import { render, staticRenderFns } from "./FormFieldCheckboxButtons.vue?vue&type=template&id=2e4c6552&scoped=true&"
import script from "./FormFieldCheckboxButtons.vue?vue&type=script&lang=js&"
export * from "./FormFieldCheckboxButtons.vue?vue&type=script&lang=js&"
import style0 from "./FormFieldCheckboxButtons.vue?vue&type=style&index=0&id=2e4c6552&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4c6552",
  null
  
)

export default component.exports